import Vue from 'vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import {
    faCheckCircle as farCheckCircle,
    faEye as farEye,
    faEyeSlash as farEyeSlash,
    faTimesCircle as farTimesCircle,
    faUser as farUser,
    faUserCircle as farUserCircle,
    faBell as farBell,
    faCircle as farCircle,
} from '@fortawesome/free-regular-svg-icons'

import {
    faApplePay as fabApplePay,
    faFacebook as fabFacebook,
    faGooglePay as fabGooglePay,
    faInstagram as fabInstagram,
} from '@fortawesome/free-brands-svg-icons'

import {
    faAngleLeft as fasAngleLeft,
    faAngleRight as fasAngleRight,
    faAnglesLeft as fasAnglesLeft,
    faAnglesRight as fasAnglesRight,
    faArrowLeft as fasArrowLeft,
    faArrowRight as fasArrowRight,
    faBell as fasBell,
    faBriefcase as fasBriefcase,
    faBurger as fasBurger,
    faCalendar as fasCalendar,
    faCaretDown as fasCaretDown,
    faCheck as fasCheck,
    faCheckCircle as fasCheckCircle,
    faChevronDown as fasChevronDown,
    faChevronRight as fasChevronRight,
    faCircle as fasCircle,
    faClock as fasClock,
    faClone as fasClone,
    faCloud as fasCloud,
    faComments as fasComments,
    faCog as fasCog,
    faCreditCard as fasCreditCard,
    faCreditCardAlt as fasCreditCardAlt,
    faCube as fasCube,
    faDivide as fasDivide,
    faEnvelope as fasEnvelope,
    faExclamationCircle as fasExclamationCircle,
    faExclamationTriangle as fasExclamationTriangle,
    faHeart as fasHeart,
    faHistory as fasHistory,
    faHouse as fasHouse,
    faInfoCircle as fasInfoCircle,
    faLocationArrow as fasLocationArrow,
    faLocationDot as fasLocationDot,
    faLock as fasLock,
    faLongArrowAltLeft as fasLongArrowAltLeft,
    faLongArrowAltRight as fasLongArrowAltRight,
    faLongArrowRight as fasLongArrowRight,
    faMapMarkerAlt as fasMapMarkerAlt,
    faMoneyBill as fasMoneyBill,
    faMotorcycle as fasMotorcycle,
    faPen as fasPen,
    faPencilAlt as fasPencilAlt,
    faPhone as fasPhone,
    faReceipt as fasReceipt,
    faRedo as fasRedo,
    faSave as fasSave,
    faSearch as fasSearch,
    faShare as fasShare,
    faShoppingBag as fasShoppingBag,
    faShoppingCart as fasShoppingCart,
    faSlidersH as fasSlidersH,
    faStar as fasStar,
    faTag as fasTag,
    faTimes as fasTimes,
    faTimesCircle as fasTimesCircle,
    faTrash as fasTrash,
    faUser as fasUser,
    faUserFriends as fasUserFriends,
    faUtensils as fasUtensils,
    faWallet as fasWallet,
    faPlus as fasPlus,
    faMinus as fasMinus,
    faComment as fasComment,
    faXmark as fasXmark,
    faArrowUpFromBracket as fasArrowUpFromBracket,
    faFilter as fasFilter,
    faGripVertical as fasGripVertical,
    faArrowDownShortWide as fasArrowDownShortWide,
} from '@fortawesome/free-solid-svg-icons'
// fa-solid fa-
library.add(
    fabApplePay,
    fabFacebook,
    fabGooglePay,
    fabInstagram,
    farBell,
    farCheckCircle,
    farCircle,
    farEye,
    farEyeSlash,
    farTimesCircle,
    farUser,
    farUserCircle,
    fasAngleLeft,
    fasAngleRight,
    fasAnglesLeft,
    fasAnglesRight,
    fasArrowLeft,
    fasArrowRight,
    fasBell,
    fasBriefcase,
    fasBurger,
    fasCalendar,
    fasCaretDown,
    fasCheck,
    fasCheckCircle,
    fasChevronDown,
    fasChevronRight,
    fasCircle,
    fasClock,
    fasClone,
    fasCloud,
    fasComments,
    fasComment,
    fasCog,
    fasCreditCard,
    fasCreditCardAlt,
    fasCube,
    fasDivide,
    fasEnvelope,
    fasExclamationCircle,
    fasExclamationTriangle,
    fasHeart,
    fasHistory,
    fasHouse,
    fasInfoCircle,
    fasLocationArrow,
    fasLocationDot,
    fasLock,
    fasLongArrowAltLeft,
    fasLongArrowAltRight,
    fasLongArrowRight,
    fasMapMarkerAlt,
    fasMinus,
    fasMoneyBill,
    fasMotorcycle,
    fasPen,
    fasPencilAlt,
    fasPhone,
    fasPlus,
    fasReceipt,
    fasRedo,
    fasSave,
    fasSearch,
    fasShare,
    fasShoppingBag,
    fasShoppingCart,
    fasSlidersH,
    fasStar,
    fasTag,
    fasTimes,
    fasTimesCircle,
    fasTrash,
    fasUser,
    fasUserFriends,
    fasUtensils,
    fasWallet,
    fasXmark,
    fasArrowUpFromBracket,
    fasFilter,
    fasGripVertical,
    fasArrowDownShortWide
)
Vue.component('Icon', FontAwesomeIcon)
